export default "__VITE_ASSET__BpnambBV__"